import React from 'react'

function ScrollSpy() {
  return (
    <div>
      <div class="spinner-border text-info" role="status">
  <span class="visually-hidden">Loading...</span>
</div>
    </div>
  )
}

export default ScrollSpy
